import './TraffickingPageController.scss';

import React from 'react';

import Loader from '../../../common/Loader';
import { useFiltersContext } from '../../../contexts/FilterContext';
import TraffickingPage from '../TraffickingPage';
import { PendingLineItemDrawerProvider } from '../TraffickingPage/contexts';

const TraffickingPageController = (): React.ReactElement => {
  const { loading } = useFiltersContext();

  if (loading) return <Loader className="page-loader" />;

  return (
    <PendingLineItemDrawerProvider>
      <TraffickingPage />
    </PendingLineItemDrawerProvider>
  );
};

export default TraffickingPageController;
